module.exports = __webpack_public_path__ + "img/koinage_logo.eb9a5f82.png";